import { render, staticRenderFns } from "./phoneLoginForm.vue?vue&type=template&id=6152bbcc&scoped=true&"
import script from "./phoneLoginForm.vue?vue&type=script&lang=js&"
export * from "./phoneLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneLoginForm.vue?vue&type=style&index=0&id=6152bbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152bbcc",
  null
  
)

export default component.exports